module.exports = __webpack_public_path__ + "static/media/MTS-logo.37cf0239.png";